import ouiBase from '@goldwasserexchange/oui';
import { useAccountHistoryTransformApiByHisMvtId } from '../api';
import { getFileNameExtensionFromArDoc } from '../../../../shared';

export const useAccountHistoryArDocFileNameExtension = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountHistoryTransformApiByHisMvtId({
    hisMvtId,
    transformFunction: getFileNameExtensionFromArDoc,
  });
  return response;
};
